import { render, staticRenderFns } from "./Amendments.vue?vue&type=template&id=68884242"
import script from "./Amendments.vue?vue&type=script&lang=js"
export * from "./Amendments.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports